import React from 'react'
import { FlatList, View } from 'react-native'
import { useQuery } from '@tanstack/react-query'

import api from '@/utils/api'
import tw from '@/styles/tailwind'
import Text from '@/components/Text'
import ProviderRow from './components/ProviderRow'


export default function ProvidersScreen() {
  // En Vinte la lista es cross-community: /vinte/providers sin community_id.
  const { isInitialLoading, data: providers } = useQuery({
    queryKey: ['vinte.providers', 'all'],
    queryFn: () => api.get(`/vinte/providers`).then(response => response.data),
  })

  const items = providers?.data ?? []

  return (
    <View style={tw`flex-1`}>
      {
        isInitialLoading &&
          <Text style={tw`my-8 text-lg text-center text-gray-400`}>Cargando...</Text>
      }

      {
        !isInitialLoading && items.length == 0 &&
          <Text style={tw`mt-25 text-lg text-center text-gray-400`}>Sin proveedores registrados</Text>
      }

      <FlatList
        data={items}
        contentContainerStyle={tw`pt-2 pb-14`}
        renderItem={({ item }) => <ProviderRow provider={item} />}
        keyExtractor={(item) => item.uuid}
      />
    </View>
  )
}
